import { RitzAPI, } from '@moderepo/mode-internal-apis';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var ProjectActionType;
(function (ProjectActionType) {
    ProjectActionType["SET_PROJECTS"] = "set projects";
    ProjectActionType["SET_PROJECT"] = "set project";
    ProjectActionType["SET_PROJECT_STATISTICS"] = "set project statistic";
})(ProjectActionType || (ProjectActionType = {}));
/**
 * Create and return an action to set the list of projects. Use this action to show the agent the list of projects he
 * has access to.
 *
 * @param projects - The list of projects to be set. Pass 'null' to unset the list.
 */
export const setProjects = (projects) => {
    return {
        type: ProjectActionType.SET_PROJECTS,
        projects,
    };
};
/**
 * Create and return an action to set a projects.
 *
 * @param project - The projects to be set.
 */
export const setProject = (project) => {
    return {
        type: ProjectActionType.SET_PROJECT,
        project,
    };
};
/**
 * Create and return an action to set the statistics data for a projects.
 *
 * @param projectId - The id of the projects the statistics data belonged to
 * @param statistics - The statistic data
 */
export const setProjectStatistics = (projectId, statistics) => {
    return {
        type: ProjectActionType.SET_PROJECT_STATISTICS,
        projectId,
        statistics,
    };
};
/**
 * Get an agent's list of projects that he has access to.
 * @param agentId - The id of the agent whose project list is to be loaded for
 * @return Project[] - The list of projects
 */
export const fetchAgentProjects = (agentId) => {
    return async (dataDispatch) => {
        const projects = await RitzAPI.getInstance().getAgentProjects(agentId);
        // projects loaded successfully, dispatch an action to add it to the state
        await dataDispatch(setProjects(projects));
    };
};
/**
 * Get an agent's specific project that he has access to.
 * @param agentId - The id of the agent whose project list is to be loaded for
 * @param projectId - The id of the project
 * @return Project - The projects
 */
export const fetchAgentProjectById = (agentId, projectId) => {
    return async (dataDispatch) => {
        const project = await RitzAPI.getInstance().getAgentProjectById(agentId, projectId);
        // projects loaded successfully, dispatch an action to add it to the state
        await dataDispatch(setProject(project));
    };
};
/**
 * Get the statistics for a project
 * @param projectId - The id of the project
 * @return ProjectStatistics - The project statistic
 */
export const fetchProjectStatistics = (projectId) => {
    return async (dataDispatch) => {
        const stats = await RitzAPI.getInstance().getProjectStatistics(projectId);
        await dataDispatch(setProjectStatistics(projectId, stats));
    };
};
/**
 * Update Project.supportToolSettings
 * @param projectId
 * @param agentId
 * @param settings
 * @returns
 */
export const updateProjectSettings = (projectId, agentId, settings) => {
    return async (dataDispatch) => {
        await RitzAPI.getInstance().updateProjectSettings(projectId, settings);
        await dataDispatch(fetchAgentProjectById(agentId, projectId));
    };
};
